import React, { useState } from "react";
import "../../styles/art/ActivitySection.css";
import { FaSearchPlus } from "react-icons/fa";

const activityImages = [
  { id: 1, src: "/images/art/activities/1.webp", caption: "Vẽ cùng bạn bè" },
  { id: 2, src: "/images/art/activities/2.webp", caption: "Lớp học sôi nổi" },
  { id: 3, src: "/images/art/activities/3.webp", caption: "Thảo luận ý tưởng" },
  { id: 4, src: "/images/art/activities/4.webp", caption: "Giờ thực hành" },
];

const ActivitySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const openLightbox = (image) => setSelectedImage(image);
  const closeLightbox = () => setSelectedImage(null);

  return (
    <section className="activity-section">
      <div className="activity-section__container">
        <h2 className="activity-section__title">Hoạt Động Nổi Bật</h2>
        <div className="activity-grid">
          {activityImages.map((img) => (
            <div
              key={img.id}
              className="activity-card"
              onClick={() => openLightbox(img)}
            >
              <img
                src={img.src}
                alt={img.caption}
                className="activity-image"
              />
              <div className="activity-overlay">
                <FaSearchPlus className="overlay-icon" />
                <p className="overlay-caption">{img.caption}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div
          className="lightbox"
          onClick={closeLightbox}
        >
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage.src}
              alt={selectedImage.caption}
            />
            <p className="lightbox-caption">{selectedImage.caption}</p>
            <button
              className="lightbox-close"
              onClick={closeLightbox}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default ActivitySection;
